import React, { useState } from 'react';
import { Card } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Badge } from '../components/ui/badge';
import BirdAvatarWithJailbirdEyes from '../components/BirdAvatarWithJailbirdEyes';
import { Check, X } from 'lucide-react';

// UPDATED: All avatars with accessories, fixed eye rendering, more color variety
export const ALL_AVATAR_OPTIONS = [
  // BRIGHT & CHEERFUL (Gender Neutral)
  { id: 2, color: '#4ECDC4', accessory: 'tiny-glasses', name: 'Smarty', description: 'Nerdy & Proud', category: 'neutral' },
  { id: 3, color: '#FFD93D', accessory: 'tiny-bow', name: 'Sunny', description: 'Bright & Cheerful', category: 'neutral' },
  { id: 5, color: '#FF8ED4', accessory: 'heart', name: 'Sweetheart', description: 'Full of Love', category: 'neutral' },
  { id: 8, color: '#6FEDD6', accessory: 'star', name: 'Starry', description: 'Dreamy & Magical', category: 'neutral' },
  { id: 9, color: '#FFB347', accessory: 'cool-shades', name: 'Chill', description: 'Too Cool for School', category: 'neutral' },
  { id: 17, color: '#FFD700', accessory: 'sparkle', name: 'Glitter', description: 'Sparkly & Shiny', category: 'neutral' },
  { id: 32, color: '#FFED4E', accessory: 'sunburst', name: 'Sunshine', description: 'Bright & Warm', category: 'neutral' },
  
  // CUTE ANIMALS (Gender Neutral)
  { id: 21, color: '#FFB3E6', accessory: 'bunny-ears', name: 'Cottontail', description: 'Hoppy & Bouncy', category: 'neutral' },
  { id: 23, color: '#FFA5BA', accessory: 'cat-ears', name: 'Whiskers', description: 'Purr-fectly Cute', category: 'neutral' },
  { id: 26, color: '#B4F8C8', accessory: 'bear-ears', name: 'Teddy', description: 'Cuddly & Warm', category: 'neutral' },
  { id: 41, color: '#FFFFFF', accessory: 'panda', name: 'Bamboo', description: 'Cuddly Panda', category: 'neutral' },
  { id: 45, color: '#90EE90', accessory: 'frog-hat', name: 'Hoppy', description: 'Froggy Friend', category: 'neutral' },
  { id: 37, color: '#FFB7B2', accessory: 'bee-wings', name: 'Buzzy', description: 'Busy Bee', category: 'neutral' },
  
  // SWEET TREATS (Gender Neutral)
  { id: 22, color: '#B4E7CE', accessory: 'donut', name: 'Sprinkles', description: 'Sweet as Sugar', category: 'neutral' },
  { id: 24, color: '#A0E7E5', accessory: 'ice-cream', name: 'Frosty', description: 'Cool & Sweet', category: 'neutral' },
  { id: 33, color: '#FFD1DC', accessory: 'lollipop', name: 'Candy', description: 'Super Sweet', category: 'neutral' },
  { id: 43, color: '#FF6B6B', accessory: 'strawberry', name: 'Berry', description: 'Sweet Berry', category: 'neutral' },
  { id: 39, color: '#FFDFD3', accessory: 'cookie', name: 'Chips', description: 'Freshly Baked', category: 'neutral' },
  { id: 19, color: '#F7B2BD', accessory: 'cherry', name: 'Cherry', description: 'Sweet & Juicy', category: 'neutral' },
  
  // MAGICAL & FANTASY (Feminine)
  { id: 42, color: '#FFB3FF', accessory: 'unicorn', name: 'Magic', description: 'Sparkly Unicorn', category: 'feminine' },
  { id: 6, color: '#C7A4FF', accessory: 'tiny-crown', name: 'Royal', description: 'Fancy & Fabulous', category: 'feminine' },
  { id: 7, color: '#FFB6C1', accessory: 'flower', name: 'Blossom', description: 'Pretty in Pink', category: 'feminine' },
  { id: 25, color: '#FFAEBC', accessory: 'rainbow', name: 'Sunny Day', description: 'Colorful & Happy', category: 'feminine' },
  { id: 29, color: '#FFCFD2', accessory: 'balloon', name: 'Float', description: 'Light as Air', category: 'feminine' },
  { id: 47, color: '#9370DB', accessory: 'witch-hat', name: 'Spooky', description: 'Magical Witch', category: 'feminine' },
  { id: 20, color: '#DDA0DD', accessory: 'butterfly', name: 'Flutter', description: 'Light & Graceful', category: 'feminine' },
  
  // COOL & EDGY (Masculine)
  { id: 14, color: '#84B6F4', accessory: 'mustache', name: 'Gentleman', description: 'Classy & Dapper', category: 'masculine' },
  { id: 13, color: '#FF6F61', accessory: 'bandana', name: 'Rebel', description: 'Wild & Free', category: 'masculine' },
  { id: 46, color: '#E0E0E0', accessory: 'astronaut', name: 'Cosmo', description: 'Space Explorer', category: 'masculine' },
  { id: 34, color: '#B9FBC0', accessory: 'game-controller', name: 'Gamer', description: 'Ready to Play', category: 'masculine' },
  { id: 31, color: '#90DBF4', accessory: 'music-note', name: 'Melody', description: 'Always Singing', category: 'masculine' },
  
  // DARK & MYSTERIOUS (Gender Neutral)
  { id: 51, color: '#2C3E50', accessory: 'tiny-glasses', name: 'Shadow', description: 'Dark & Mysterious', category: 'neutral' },
  { id: 52, color: '#34495E', accessory: 'cool-shades', name: 'Midnight', description: 'Night Owl', category: 'neutral' },
  { id: 53, color: '#1A1A2E', accessory: 'star', name: 'Eclipse', description: 'Dark Star', category: 'neutral' },
  { id: 54, color: '#16213E', accessory: 'tiny-crown', name: 'Obsidian', description: 'Dark Royalty', category: 'neutral' },
  
  // NEON & ELECTRIC (Gender Neutral)
  { id: 55, color: '#00FF00', accessory: 'sparkle', name: 'Neon', description: 'Electric Green', category: 'neutral' },
  { id: 56, color: '#FF00FF', accessory: 'star', name: 'Rave', description: 'Party Vibes', category: 'neutral' },
  { id: 57, color: '#00FFFF', accessory: 'sunburst', name: 'Cyber', description: 'Digital Dream', category: 'neutral' },
  { id: 58, color: '#FF1493', accessory: 'lightning', name: 'Volt', description: 'High Energy', category: 'neutral' },
  
  // FUN & QUIRKY (Gender Neutral)
  { id: 10, color: '#B19CD9', accessory: 'party-hat', name: 'Party', description: 'Always Celebrating', category: 'neutral' },
  { id: 44, color: '#8B7355', accessory: 'coffee', name: 'Mocha', description: 'Cozy Café', category: 'neutral' },
  { id: 48, color: '#FFB6C1', accessory: 'headphones', name: 'Beats', description: 'Music Lover', category: 'neutral' },
  { id: 49, color: '#FFE5B4', accessory: 'sushi', name: 'Wasabi', description: 'Sushi Roll', category: 'neutral' },
  { id: 50, color: '#C1E1C1', accessory: 'avocado', name: 'Guac', description: 'Avo-cutie', category: 'neutral' },
  { id: 38, color: '#E2F0CB', accessory: 'cactus', name: 'Prickles', description: 'Sharp but Sweet', category: 'neutral' },
  { id: 27, color: '#FBE7C6', accessory: 'pizza', name: 'Pepperoni', description: 'Cheesy & Fun', category: 'neutral' },
  { id: 28, color: '#A0C4FF', accessory: 'moon', name: 'Dreamer', description: 'Sleepy & Peaceful', category: 'neutral' },
  { id: 35, color: '#FEC8D8', accessory: 'present', name: 'Gift', description: 'Full of Surprises', category: 'neutral' },
  { id: 36, color: '#D4F1F4', accessory: 'snowflake', name: 'Frosty', description: 'Cool & Crisp', category: 'neutral' },
];

const AvatarSelectionPage = () => {
  const [selectedIds, setSelectedIds] = useState([]);
  const [filter, setFilter] = useState('all'); // all, neutral, feminine, masculine

  const toggleSelection = (id) => {
    if (selectedIds.includes(id)) {
      setSelectedIds(selectedIds.filter(i => i !== id));
    } else {
      setSelectedIds([...selectedIds, id]);
    }
  };

  const filteredAvatars = filter === 'all' 
    ? ALL_AVATAR_OPTIONS 
    : ALL_AVATAR_OPTIONS.filter(a => a.category === filter);

  return (
    <div className="min-h-screen bg-background p-4 sm:p-8">
      <div className="container mx-auto max-w-7xl">
        {/* Header */}
        <div className="text-center mb-8">
          <h1 className="text-4xl sm:text-5xl font-heading font-bold mb-4">
            <span className="text-gradient-primary">Choose Your Favorite Avatars</span>
          </h1>
          <p className="text-lg text-muted-foreground mb-6">
            Click to select as many as you want! Selected: <span className="text-primary font-bold">{selectedIds.length}</span>
          </p>
          
          {/* Filter Buttons */}
          <div className="flex flex-wrap justify-center gap-2 mb-6">
            <Button 
              variant={filter === 'all' ? 'default' : 'outline'}
              onClick={() => setFilter('all')}
              size="sm"
            >
              All ({ALL_AVATAR_OPTIONS.length})
            </Button>
            <Button 
              variant={filter === 'neutral' ? 'default' : 'outline'}
              onClick={() => setFilter('neutral')}
              size="sm"
            >
              Gender Neutral ({ALL_AVATAR_OPTIONS.filter(a => a.category === 'neutral').length})
            </Button>
            <Button 
              variant={filter === 'feminine' ? 'default' : 'outline'}
              onClick={() => setFilter('feminine')}
              size="sm"
            >
              Feminine ({ALL_AVATAR_OPTIONS.filter(a => a.category === 'feminine').length})
            </Button>
            <Button 
              variant={filter === 'masculine' ? 'default' : 'outline'}
              onClick={() => setFilter('masculine')}
              size="sm"
            >
              Masculine ({ALL_AVATAR_OPTIONS.filter(a => a.category === 'masculine').length})
            </Button>
          </div>
        </div>

        {/* Avatar Grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4 mb-8">
          {filteredAvatars.map((avatar) => {
            const isSelected = selectedIds.includes(avatar.id);
            
            return (
              <Card
                key={avatar.id}
                onClick={() => toggleSelection(avatar.id)}
                className={`p-4 cursor-pointer transition-all relative ${
                  isSelected
                    ? 'border-primary bg-primary/10 shadow-lg ring-2 ring-primary'
                    : 'border-border hover:border-primary/50 hover:shadow-md'
                }`}
              >
                {isSelected && (
                  <div className="absolute top-2 right-2 w-6 h-6 rounded-full bg-primary text-primary-foreground flex items-center justify-center z-10">
                    <Check className="w-4 h-4" />
                  </div>
                )}
                
                <Badge className="absolute top-2 left-2 text-xs z-10" variant="secondary">
                  {avatar.category === 'neutral' ? '⚪' : avatar.category === 'feminine' ? '💗' : '💙'}
                </Badge>
                
                <div className="flex flex-col items-center">
                  <div className="relative mb-2">
                    <BirdAvatarWithJailbirdEyes 
                      avatarId={avatar.id}
                      color={avatar.color}
                      accessory={avatar.accessory}
                      size={80}
                    />
                  </div>
                  <p className="font-semibold text-sm text-center">{avatar.name}</p>
                  <p className="text-xs text-muted-foreground text-center">{avatar.description}</p>
                </div>
              </Card>
            );
          })}
        </div>

        {/* Selection Summary */}
        {selectedIds.length > 0 && (
          <Card className="p-6 bg-gradient-card sticky bottom-4 shadow-2xl">
            <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
              <div>
                <h3 className="font-semibold text-lg mb-2">
                  {selectedIds.length} Avatar{selectedIds.length !== 1 ? 's' : ''} Selected
                </h3>
                <div className="flex flex-wrap gap-2">
                  {selectedIds.map(id => {
                    const avatar = ALL_AVATAR_OPTIONS.find(a => a.id === id);
                    return (
                      <Badge key={id} variant="secondary" className="text-xs">
                        {avatar.name}
                      </Badge>
                    );
                  })}
                </div>
              </div>
              <div className="flex gap-2">
                <Button 
                  variant="outline" 
                  onClick={() => setSelectedIds([])}
                  size="sm"
                >
                  <X className="w-4 h-4 mr-2" />
                  Clear All
                </Button>
                <Button 
                  onClick={() => {
                    const avatarList = selectedIds.map(id => {
                      const avatar = ALL_AVATAR_OPTIONS.find(a => a.id === id);
                      return `${id} (${avatar.name})`;
                    }).join(', ');
                    navigator.clipboard.writeText(selectedIds.join(', '));
                    alert(`Copied ${selectedIds.length} avatar IDs to clipboard!\n\n${avatarList}`);
                  }}
                  size="sm"
                  className="bg-gradient-primary"
                >
                  <Check className="w-4 h-4 mr-2" />
                  Confirm Selection
                </Button>
              </div>
            </div>
          </Card>
        )}
      </div>
    </div>
  );
};

export default AvatarSelectionPage;
